// 팀의 값 중 여러 창이 함께 쓰는 것.

/**
 * 태그 칸의 글자를 보낼 목록으로 — 쉼표로 가르고, 빈 것과 20자를 넘는 것은 빼고, 겹친 것은 하나로 둔다.
 * 팀을 만드는 창과 태그를 고치는 창이 같은 칸을 같은 규칙으로 읽는다.
 */
export const splitTags = (raw: string) =>
  [...new Set(raw.split(',').map((t) => t.trim()).filter((t) => t.length > 0 && t.length <= 20))]
